import React from 'react';
import { Box } from '@mafc/trolly';

import COLORS from 'theme/colors';

const EnableSubstitutionLayout: React.FC<{
  children: React.ReactNode;
  isNewC4Journey?: boolean;
}> = ({ children, isNewC4Journey }) => {
  return isNewC4Journey ? (
    <Box as="div" elevation={0} mb={3} paddingRight={3} pl={0} pb={13}>
      {children}
    </Box>
  ) : (
    <Box
      as="div"
      bg={'rgba(26, 79, 155, 0.05)'}
      elevation={0}
      mb={3}
      mx={[null, 4, 0]}
      px={[3, null, 4]}
      py={13}
      css={{
        border: `1px solid ${COLORS.WILD_SAND}`,
        borderRadius: '10px',
      }}
    >
      {children}
    </Box>
  );
};

export default EnableSubstitutionLayout;
